import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class ContributionResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  list(params) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data) {
    return super
      .post(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }
}
